// covered-by: frontends/carrie/src/ask-v2/routes/__tests__/pageRoutes.test.ts
// eslint-disable-next-line import/named
import { createRoute } from "@tanstack/react-router";

import { askV2AuthLayoutRoute } from "./authLayout";

import { AskV2ChatPage } from "../pages/AskV2ChatPage";

export const askV2ChatReviewRoute = createRoute({
  getParentRoute: () => askV2AuthLayoutRoute,
  path: "ask-puntt/$chatId/reviews/$reviewId",
  component: AskV2ChatReviewRoutePage,
});

export const askV2ChatReviewCommentRoute = createRoute({
  getParentRoute: () => askV2AuthLayoutRoute,
  path: "ask-puntt/$chatId/reviews/$reviewId/comments/$commentId",
  component: AskV2ChatReviewCommentRoutePage,
});

function AskV2ChatReviewRoutePage() {
  const { chatId, reviewId } = askV2ChatReviewRoute.useParams();
  return <AskV2ChatPage key={chatId} chatId={chatId} reviewId={reviewId} />;
}

function AskV2ChatReviewCommentRoutePage() {
  const { chatId, reviewId, commentId } =
    askV2ChatReviewCommentRoute.useParams();
  return (
    <AskV2ChatPage
      key={chatId}
      chatId={chatId}
      reviewId={reviewId}
      commentId={commentId}
    />
  );
}
